/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { bemGenerator, animationUtils } from '@prisjakt/ui-base';
import { get } from './map';

import './link.scss';

const styles = bemGenerator('pj-ui-scroll-link');

export const SCROLL_DURATION = 200;

class ScrollLink extends React.Component {
  scrollTo(domNode) {
    const { direction, animate } = this.props;
    if (!domNode) {
      return;
    }

    const offset = this.props.calculateOffset();
    const from = window.pageYOffset;
    const to = domNode.offsetTop - offset;

    if (direction === 'up' && from < to) {
      return;
    }

    if (direction === 'down' && from > to) {
      return;
    }

    // Init scroll animation.
    animationUtils.tween({
      from,
      to,
      duration: animate ? SCROLL_DURATION : 0,
      onUpdate(value) {
        window.scrollTo(0, Math.round(value));
      },
    });
  }

  render() {
    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
      <span
        className={styles.block}
        onClick={e => {
          this.props.onClick(e);

          let contains = true;
          let current = e.target;

          while (contains) {
            contains = current && e.currentTarget.contains(current);

            // Exit while loop if we should scroll
            if (current && this.props.shouldScroll(current)) {
              this.scrollTo(get(this.props.to));
              break;
            }

            current = current && current.parentNode;
          }
        }}
      >
        {this.props.children}
      </span>
    );
  }
}

const { node, func, string, oneOf, bool } = PropTypes;

ScrollLink.propTypes = {
  to: string.isRequired,
  shouldScroll: func,
  calculateOffset: func,
  children: node,
  direction: oneOf(['up', 'down', 'both']),
  animate: bool,
  onClick: func,
};

ScrollLink.defaultProps = {
  shouldScroll: () => true,
  calculateOffset: () => 0,
  children: null,
  direction: 'both',
  animate: true,
  onClick: () => {},
};

export default ScrollLink;
